<template>
  <div>
    <Header :self="self" />
    <div class="container main">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <form @submit.prevent="sendPassword" :disabled="submitting.sendPassword">
        <h5>Forgot Password</h5>
        <div class="content">
          <div class="form-group" v-bind:class="{ 'form-group-error': $v.sendPasswordRequest.userReference.$error }">
            <label for="password">Enter Username or Email Address</label>
            <input type="email" class="form-control" id="password" v-model="sendPasswordRequest.userReference" v-model.trim.lazy="$v.sendPasswordRequest.userReference.$model" />
            <div class="error-input">Please provide your username or email address</div>
          </div>
          <button class="btn btn-primary" @click="sendPassword()" :disabled="submitting.sendPassword">Send</button>
        </div>
      </form>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState } from "vuex";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: { Header, Footer },
    data() {
      return {
        sendPasswordRequest: { token: null, password: null },
        error: null,
        submitting: { sendPassword: false },
      };
    },
    head() {
      return {
        title: "Quozio - Forgot Password",
        meta: [
          { hid: "description", name: "description", content: "Reset your Quozio password" }
        ]
      }
    },
    async asyncData({ store, app }) {
      await store.dispatch("self/get", app.$cookies);
    },
    methods: {
      async sendPassword() {
        this.error = null;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.submitting.sendPassword = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.post("/users/sendPassword", { userReference: this.sendPasswordRequest.userReference }, null, { suppressToken: true });
        this.submitting.sendPassword = false;
        if (response.error) {
          this.error = response.error;
          this.$nuxt.$loading.finish();
          return;
        }

        this.$nuxt.$loading.finish();
        let toast = this.$toasted.show("Email Sent!", {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
          iconPack: "fontawesome",
          icon: "thumbs-up",
          type: "success",
          keepOnHover: true
        });
      }
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
    validations: {
      sendPasswordRequest: {
        userReference: {
          required
        }
      }
    }
  };
</script>
